
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"72","height":"72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52.677 44.654a5.241 5.241 0 11-10.483 0 5.241 5.241 0 0110.483 0z","fill":"#FFD250"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 25.098l1.427 9.44 55.693-.543-.829-9.945L7 25.098z","fill":"#5CE8AD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.457 44.114l-.68 18.23 5.467.158.679-18.23-5.466-.158z","fill":"#0BDBF6"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.381 39.093l-9.771 9.018 2.703 2.93 9.771-9.019-2.703-2.929z","fill":"#0BDBF6"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.514 48.795l-9.086-9.708-2.91 2.724 9.086 9.708 2.91-2.724z","fill":"#0BDBF6"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M52.11 44.579a4.253 4.253 0 11-8.507 0 4.253 4.253 0 018.507 0z","stroke":"#000"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M57.64 44.176a4.253 4.253 0 11-8.506 0 4.253 4.253 0 018.507 0z","stroke":"#000"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"charge_credit_card_svg__a","maskUnits":"userSpaceOnUse","x":"7","y":"4","width":"58","height":"59"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 62.502h57.12V4.175H7v58.327z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#charge_credit_card_svg__a)"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M9.51 53.928h52.1V19.186H9.51v34.742z","stroke":"#000"}})])])
          )
        }
      }
    